export default __webpack_public_path__ + "7bdcce82794a995ff8ba7c0a2e5f615a.png";